// import { useWeb3React } from "@web3-react/core";
import { observer } from "mobx-react";
import React from "react";
import { FarmingPool } from "types";
import GlobalSection from "./GlobalSection/GlobalSection";
import UserInteractions from "./UserInteractions/UserInteractions";
import UserSection from "./UserSection/UserSection";
import "./FarmingPool.scss";
import PoolStore from "stores/PoolStore";
import Loader from "react-loader-spinner";

type Props = {
  pool: FarmingPool;
};

function Pool({ pool }: Props) {
  const data = PoolStore.poolData.get(pool.name);

  if (!data) {
    PoolStore.fetchPoolData(pool);
    return (
      <div className="item pool">
        <div className="item-content">
          <Loader type="RevolvingDot" color="blue" height={200} width={200} style={{ width: "100%" }} />
        </div>
      </div>
    );
  }

  return (
    <div className="item pool">
      <div className="item-content">
        <GlobalSection pool={pool} data={data} />
        <UserSection pool={pool} data={data} />
        <UserInteractions pool={pool} data={data} />
      </div>
    </div>
  );
}

export default observer(Pool);
